import useVerticalResource from "./useVerticalResource"; // adjust import

const ProviderCell = ({ text, record, currentResource, handleResourceDropCb, allowDropOnSchedular, props, Component }) => {
  const { drop } = useVerticalResource({ handleResourceDropCb, currentResource });
  return (
    <div
      style={{ paddingLeft: "5px" }}
      onClick={(e) => e.stopPropagation()}
      ref={allowDropOnSchedular ? drop : null}
    >
      {record?.provider === "Add Provider" ? (
        <span>{text}</span>
      ) : (
        <Component resource={currentResource} hideRoomName={true} {...props} />
      )}
    </div>
  );
};

export default ProviderCell;
